import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';

const CallsBarGraph = (props) => {
  const data = props?.data;
  const maxVal = data
  ? Math.max(...data.map(Math.abs))
  : undefined; // or some default value

  return (
    <div
      className='ms-auto'
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
      }}
    >
      {
        data?.map((val, index) => {
          let height = Math.abs(Math.ceil((val / maxVal) * 40)) || 0;
          if (height == 0) 
          {
            height = 0.1
          }
          const isNegative = val < 0;

          return (
            <>
            <UncontrolledTooltip
              placement="top"
              target={`tooltip-bar-${props?.tooltip}-${index}`}
          >
              {val}
          </UncontrolledTooltip>
            <div
              id={`tooltip-bar-${props?.tooltip}-${index}`}
              key={index}
              style={{
                height: `${height}px`,
                backgroundColor: props?.color,
                minWidth: '16px',
                maxWidth: '40px',
                display: 'inline-block',
                marginRight: '5px',
                color: props?.color,
                fontSize: '12px',
                transform: isNegative ? 'translateY(100%)' : '',
              }}
            >
            </div>
            </>
          );
        })
      }
    </div>
  );
};

export default CallsBarGraph;
